<template>
    <div class="survey-multiline-container">
        <span>{{field.name}}</span>
        <div class="print">{{ model }}</div>
        <md-field class="not-print">
            <label>{{readonlyMode ? '': field.placeholder || "Wprowadź tekst"}}</label>
            <md-textarea 
              v-model="model" 
              v-on:keyup="onCommentsKeyup" 
              v-on:change="onModelChange" 
              :disabled="readonlyMode"
            ></md-textarea>
        </md-field>
    </div>
</template>

<script>
import store from '../../store';
import {resizeTextarea, resizeAllTextarea} from '../../app-func';

export default {
  name: 'SurveyMultiline',
  props: ['field'],
  data() {
    return {
      model: this.field.value,
      readonlyMode: store.state.visit.readonlyMode,
    };
  },
  methods: {
    onCommentsKeyup (event) {
      resizeTextarea(event);
    },
    onModelChange() {
      // this.model = this.model.replace(/[ \t]+$/g, '');
      this.model = this.model.replace(/^[\s\t]*(\r\n|\n|\r)([ \t]+$)/gm, '');

      this.$emit('modelChange', {
        newVal: this.model,
        oldVal: this.field.value,
        fieldId: this.field.id,
      });
      this.field.completed = true;
      this.field.value = this.model;
      this.$emit('nodeChange', this.field);
    },
  },
  mounted() {
    resizeAllTextarea();
  },
};
</script>

<style src="./SurveyMultiline.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SurveyMultiline/SurveyMultiline.vue